import type { MenuItems } from "../types/menu";

// 사이드바 메뉴 정의
// - children: 하위 메뉴
// - permission: localStorage의 accountType 기준
//   - string: 단일 권한 (예: 'academy')
//   - string[]: 여러 권한 중 하나면 노출 (예: ['academy', 'agency'])
const menuItems: MenuItems = [
  {
    id: "learning",
    title: "학습관리",
    path: "",
    icon: "book",
    permission: ["academy", "root", "teacher"], // 원장·본사 + 교사(teacher) 노출. 교사는 교재 부여하기·링키고 셋팅 제외(각 항목 permission으로 차단)
    children: [
      // {
      //   id: "member-management",
      //   title: "회원 정보",
      //   path: "/member-management",
      //   permission: ["root", "agency", "academy"],
      // },
      {
        id: "learning-history",
        title: "교재 부여하기",
        path: "/learning-history",
        permission: ["academy", "agency", "root"],
      },
      {
        id: "assignment-status",
        title: "과제 현황",
        path: "/assignment-status",
      },
      {
        id: "student-history",
        title: "학생별 관리",
        path: "/student-history",
      },
      {
        id: "ranking",
        title: "학원 랭킹",
        path: "/ranking",
      },

      {
        id: "ranking-personal",
        title: "개인 랭킹",
        path: "/ranking-personal",
      },
      {
        id: "learning-statistics",
        title: "학생 통계",
        path: "/learning-statistics",
      },
      {
        id: "achievement-management",
        title: "업적 관리",
        path: "/achievement-management",
      },
      {
        id: "reengkigo-setting",
        title: "링키고 세팅",
        path: "/reengkigo-setting",
        permission: "academy",
      },
    ],
  },
  {
    id: "hq",
    title: "본사관리",
    path: "",
    icon: "office",
    permission: "root", // 본사(root) 전용 관리 페이지 모음
    children: [
      {
        id: "book-table",
        title: "교재 카탈로그",
        path: "/book-table",
        permission: "root", // books(교재 목록) 관리는 본사 전용
      },
      {
        id: "online-users",
        title: "MAU / DAU",
        path: "/online-users",
        permission: "root",
      },
      {
        id: "achievement-admin",
        title: "업적 관리",
        path: "/achievement-admin",
        permission: "root",
      },
      {
        id: "quokkaroom-admin",
        title: "쿼카룸 카탈로그",
        path: "/quokkaroom-admin",
        permission: "root",
      },
      {
        id: "alimtalk-templates",
        title: "알림톡 템플릿",
        path: "/alimtalk-templates",
        permission: "root",
      },
      {
        id: "alimtalk-test",
        title: "알림톡 테스트",
        path: "/alimtalk-test",
        permission: "root",
      },
    ],
  },
];

export default menuItems;
